// extracted by mini-css-extract-plugin
module.exports = {"title":"usermenu_title__kxk_S"};